import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=58311b49&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/navbar.css?vue&type=style&index=0&id=58311b49&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58311b49",
  null
  
)

export default component.exports